
export const formatDateTime = (dateValue) => {
  if (!dateValue) return "";

  try {
    const date = new Date(dateValue);
    return date.toLocaleString("en-US", {
      dateStyle: "short",
      timeStyle: "short",
    });
  } catch (error) {
    console.error("Invalid date value:", dateValue, error);
    return "";
  }
};


export const formatDate = (dateValue) => {
  if (!dateValue) return "";
  return new Date(dateValue).toLocaleDateString("en-US", {
    dateStyle: "short",
  });
};


export const formatTime = (dateValue) => {
  if (!dateValue) return "";
  return new Date(dateValue).toLocaleTimeString("en-US", {
    timeStyle: "short",
  });
};

export const getISODate = (dateValue) => {
  if (!dateValue) return "";
  return new Date(dateValue).toISOString().split("T")[0];
};

export const generateYearOptions = (
  startYear = 2014,
  endYear = new Date().getFullYear() + 20
) => {
  return Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => {
      const year = startYear + i;
      return {
        value: year.toString(),
        label: year.toString(),
      };
    }
  ).reverse();
};